// admin/wa-link.js — helper para gerar link de conversa WhatsApp com aluno.
//
// A planilha de alunos traz telefone no formato '71992840361' (DDD + número,
// sem código do país). Este módulo prefixa 55 quando necessário e monta um
// link wa.me com mensagem pré-preenchida pela Customer Success (Gabi).
//
// API pública:
//   normalizeTel(tel)          → '5571992840361' | null
//   buildMensagem(nome, faltas) → string (mensagem pré-preenchida)
//   waLink(tel, nome, faltas)  → 'https://wa.me/...' | null
//
// `faltas` é opcional. Cada item: { materia, data } (data em 'dd/MM/yyyy').

export function normalizeTel(tel) {
  const digits = String(tel || '').replace(/\D/g, '');
  if (!digits) return null;
  if (digits.length < 10) return null;           // inválido (sem DDD)
  if (digits.length <= 11) return '55' + digits; // BR: DDD + número
  return digits;                                 // já tem código do país
}

function primeiroNome(nome) {
  return String(nome || '').trim().split(/\s+/)[0] || '';
}

// Formata data 'dd/MM/yyyy' → 'dd/MM'. Se vier em outro formato, retorna original.
function fmtData(data) {
  const m = String(data || '').match(/^(\d{1,2})\/(\d{1,2})/);
  if (!m) return String(data || '');
  return `${m[1].padStart(2, '0')}/${m[2].padStart(2, '0')}`;
}

export function buildMensagem(nome, faltas) {
  const primeiro = primeiroNome(nome);
  const lista = Array.isArray(faltas) ? faltas : [];

  if (!lista.length) {
    return `Oi ${primeiro}! Gabi aqui. Estou entrando em contato para saber se está tudo bem.`;
  }

  // Lista cada falta separada: 'Oratória (23/01), Oratória (05/02), Dicção (12/02)'
  const itens = lista
    .map(f => {
      const mat = String(f.materia || 'A definir').trim();
      const data = fmtData(f.data);
      return data ? `${mat} (${data})` : mat;
    })
    .join(', ');

  return `Oi ${primeiro}! Gabi aqui. Vi que você faltou nas matérias: ${itens}, então estou entrando em contato para saber se está tudo bem.`;
}

export function waLink(tel, nome, faltas) {
  const num = normalizeTel(tel);
  if (!num) return null;
  const msg = buildMensagem(nome, faltas);
  return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
}

// SVG do ícone WhatsApp — reusado pelo botão do overlay.
export const WA_ICON_SVG = `<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.5 0 .17 5.34.17 11.9c0 2.1.56 4.14 1.62 5.94L0 24l6.31-1.65a11.87 11.87 0 0 0 5.75 1.47h.01c6.55 0 11.89-5.34 11.89-11.9 0-3.18-1.24-6.17-3.44-8.44ZM12.07 21.8h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.22-3.74.98 1-3.64-.24-.38a9.88 9.88 0 1 1 18.36-5.26c0 5.45-4.44 9.9-9.88 9.9Zm5.42-7.41c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.66.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.48-1.77-1.65-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.91-2.2-.24-.58-.48-.5-.66-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5s1.07 2.9 1.22 3.1c.15.2 2.1 3.21 5.09 4.5.71.31 1.27.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35Z"/></svg>`;
